/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegacyTournamentStage
 */
export interface LegacyTournamentStage {
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentStage
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentStage
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentStage
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentStage
     */
    stageType?: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyTournamentStage
     */
    orderIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentStage
     */
    bracket?: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyTournamentStage
     */
    defaultBlockDurationMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof LegacyTournamentStage
     */
    interMatchBreakMinutes?: number;
}

/**
 * Check if a given object implements the LegacyTournamentStage interface.
 */
export function instanceOfLegacyTournamentStage(value: object): value is LegacyTournamentStage {
    return true;
}

export function LegacyTournamentStageFromJSON(json: any): LegacyTournamentStage {
    return LegacyTournamentStageFromJSONTyped(json, false);
}

export function LegacyTournamentStageFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegacyTournamentStage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'name': json['name'] == null ? undefined : json['name'],
        'stageType': json['stageType'] == null ? undefined : json['stageType'],
        'orderIndex': json['orderIndex'] == null ? undefined : json['orderIndex'],
        'bracket': json['bracket'] == null ? undefined : json['bracket'],
        'defaultBlockDurationMinutes': json['defaultBlockDurationMinutes'] == null ? undefined : json['defaultBlockDurationMinutes'],
        'interMatchBreakMinutes': json['interMatchBreakMinutes'] == null ? undefined : json['interMatchBreakMinutes'],
    };
}

export function LegacyTournamentStageToJSON(json: any): LegacyTournamentStage {
    return LegacyTournamentStageToJSONTyped(json, false);
}

export function LegacyTournamentStageToJSONTyped(value?: LegacyTournamentStage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'categoryId': value['categoryId'],
        'name': value['name'],
        'stageType': value['stageType'],
        'orderIndex': value['orderIndex'],
        'bracket': value['bracket'],
        'defaultBlockDurationMinutes': value['defaultBlockDurationMinutes'],
        'interMatchBreakMinutes': value['interMatchBreakMinutes'],
    };
}

